module.exports = __webpack_public_path__ + "img/logo.264cf05e.png";